/**
 * Pure deep(ish) array equality used by the modifier change detection.
 *
 * Replaces the former `Array.prototype.equals` monkey-patch (previously defined
 * in views/Order/StandardOrder.vue and implemented in utils/compareArrays.js).
 * Patching a built-in prototype is global, leak-prone and order-of-import
 * sensitive, so this is a plain function instead.
 *
 * Semantics are preserved from the old patch:
 *   - a falsy `b` returns false
 *   - different lengths return false
 *   - nested arrays are compared recursively
 *   - everything else is compared with loose equality (==), matching the
 *     original behaviour (object instances are never equal).
 */
export default function arraysEqual(a, b) {
  if (!Array.isArray(a) || !b) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, l = a.length; i < l; i++) {
    if (Array.isArray(a[i]) && Array.isArray(b[i])) {
      if (!arraysEqual(a[i], b[i])) {
        return false;
      }
    } else if (a[i] != b[i]) {
      return false;
    }
  }
  return true;
}
